import React, { useState, useEffect } from "react";
import { useAppSelector } from "../../context-store";
import Layout from "../../components/layout/Layout";
import "../../assets/InnerCSS/plugins/bootstrap/css/bootstrap.min.css";
import "../../assets/InnerCSS/plugins/font-awesome/css/font-awesome.min.css";
import "../../assets/InnerCSS/plugins/icomoon/style.css";
import "../../assets/InnerCSS/plugins/uniform/css/default.css";
import "../../assets/InnerCSS/plugins/switchery/switchery.min.css";
import "../../assets/InnerCSS/plugins/nvd3/nv.d3.min.css";
import "../../assets/InnerCSS/css/styles.css";
import "../../assets/InnerCSS/css/custom.css";
import JobPostingParams from "../../models/common/PageParms";
import { useParams } from "react-router-dom";
import masterDataService from "../../services/master-data-service";
import IdNameModel from "../../models/common/IdNameModel";
import toasterUtils from "../../utils/toaster-utils";
import jobPostingService from "../../services/company/job-posting-service";
import { useHistory } from "react-router";
import ShortlistedProfilesComponent from "../../components/company/shortlisted-profiles/ShortlistedProfilesComponent";
import { RoleEnum } from "../../models/enums/RoleEnum";
import modalUtils from "../../utils/modal-utils";
import NavigateNextOutlinedIcon from '@mui/icons-material/NavigateNextOutlined';
import ViewEscalationComponent from "../../components/company/add-profiles/ViewEscalationComponent";
import { GeneralPoupConfig, ModalSize } from "../../models/modal-types";
import { ScreenEnum } from "../../models/enums/StatusEnum";

const ShortlistedProfiles = () => {
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const history = useHistory();
    const requestParams: JobPostingParams = useParams();
    const [jobCode, setJobCode] = useState<string>("");
    const [secondarySkillList, setSecondarySkillList] = useState<IdNameModel[]>([]);
    const [ratingList, setRatingList] = useState<IdNameModel[]>([]);
    const [roleId, setRoleId] = useState<number>(loggedInUser !== null ? parseInt(loggedInUser.roleId) : 0);
    const [escalationStatusList, setEscalationStatusList] = useState<IdNameModel[]>([]);
    const [refreshEscalationStatus, setRefreshEscalationStatus] = useState<number>(2);

    useEffect(() => {
        if (loggedInUser) {
            getTotalRatings();
            getJobPosting(requestParams.requirementId);
            getEscalationStatusList();
        }
    }, []);

    const getJobPosting = (requirementId: string) => {
        modalUtils.showLoader();
        jobPostingService.getJobPostingById(requirementId).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setJobCode(res.data.jobCode);
            if (res.data.primarySkillId !== null) {
                getSecondarySkills(res.data.primarySkillId);
            }
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    const getSecondarySkills = (primarySkillId: number) => {
        masterDataService.loadSecondarySkills(primarySkillId).then((res) => {
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setSecondarySkillList(res.items);
        }).catch((error) => {
            toasterUtils.showError(error);
        });
    };

    const getTotalRatings = () => {
        masterDataService.loadTotalRatings().then((res) => {
            setRatingList(res);
        }).catch((error) => {
            toasterUtils.showError(error);
        });
    };

    const getEscalationStatusList = () => {
        masterDataService.loadStatusByScreen(ScreenEnum.EscalationsStatus).then((res) => {
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setEscalationStatusList(res.items);
            setRefreshEscalationStatus(refreshEscalationStatus * 5);
        }).catch((error) => {
            setRefreshEscalationStatus(refreshEscalationStatus * 5);
            toasterUtils.showError(error);
        });
    };

    const onViewEscalationsHandler = (requirementId: string) => {
        const config: GeneralPoupConfig = {
            title: "Escalations",
            content: (
                <ViewEscalationComponent
                    requirementId={requirementId}
                    statusList={escalationStatusList} />
            ),
            size: ModalSize.XL,
            className: "model-min-height-500"
        };
        modalUtils.showPopup(config);
    };

    return (
        <Layout>
            <div className="breadcrumb-text">
                <a onClick={() => history.push("/")}>Home</a> <i className="fa-solid fa-angle-right"></i> <a onClick={() => history.push("/all-job-postings")}>Job Postings</a> <i className="fa-solid fa-angle-right"></i> Shortlisted Profiles
            </div>
            <div className="page-title">
                <div className="row">
                    <div className="col-md-12">
                        <h4 className="breadcrumb-header"> Shortlisted Profiles: <span>{jobCode}</span> </h4>
                    </div>
                </div>
            </div>
            {jobCode !== "" && secondarySkillList.length > 0 && ratingList.length > 0 &&
                <ShortlistedProfilesComponent
                    secondarySkillList={secondarySkillList}
                    ratingList={ratingList}
                    requirementId={requestParams.requirementId} />
            }
            <div className="row related-profiles-navigation">
                {roleId === parseInt(RoleEnum.ClientRecruiter.toString()) &&
                    <div className="email-actions col-md-8">
                        <a className="btn" onClick={() => history.push("/add-profiles/" + requestParams.requirementId)}><NavigateNextOutlinedIcon /> Add Profiles</a>
                        <a className="btn" onClick={() => history.push("/related-profiles/" + requestParams.requirementId)}><NavigateNextOutlinedIcon /> Related Candidate</a>
                        <a className="btn" onClick={() => history.push("/applied-candidates/" + requestParams.requirementId)}><NavigateNextOutlinedIcon /> Applied Candidate</a>
                        <a className="btn" onClick={() => onViewEscalationsHandler(requestParams.requirementId)}><NavigateNextOutlinedIcon /> Escalations</a>
                    </div>
                }
                {(roleId === parseInt(RoleEnum.ClientAdmin.toString()) || roleId === parseInt(RoleEnum.ClientLead.toString())) &&
                    <div className="email-actions col-md-8">
                        {/* <a className="btn" onClick={() => history.push("/add-profiles/" + requestParams.requirementId)}><span> <img src={AppliedImage} alt="" className={companyClasses.jobPostingProfilesImageClass}></img></span> <b>Add Profiles</b></a> */}
                        <a className="btn" onClick={() => history.push("/related-profiles/" + requestParams.requirementId)}><NavigateNextOutlinedIcon /> Related Candidate</a>
                        <a className="btn" onClick={() => history.push("/applied-candidates/" + requestParams.requirementId)}><NavigateNextOutlinedIcon /> Applied Candidate</a>
                        <a className="btn" onClick={() => onViewEscalationsHandler(requestParams.requirementId)}><NavigateNextOutlinedIcon /> Escalations</a>
                    </div>
                }
                {roleId === parseInt(RoleEnum.VendorRecruiter.toString()) &&
                    <div className="email-actions col-md-8">
                        <a className="btn" onClick={() => history.push("/add-profiles/" + requestParams.requirementId)}><NavigateNextOutlinedIcon /> Add Profiles</a>
                        <a className="btn" ><NavigateNextOutlinedIcon /> Related Candidate</a>
                        <a className="btn" ><NavigateNextOutlinedIcon /> Applied Candidate</a>
                    </div>
                }
            </div>
        </Layout>
    );
};
export default ShortlistedProfiles;